query lpTempTasksLevel {
  lpTempTasksLevel {
    id
    propsContent {
      id
      title
      type
      props
      images {
        id
        compressedImage {
          webp {
            lg
            md
            sm
            xl
            xs
          }
        }
      }
    }
    numLevel
    name
    requiredXp
    categories {
      isCompleted
      rewardClaimed
      actions {
        id
      }
      tasks {
        userTask {
          id
          isCompleted
          rewardClaimed
          amount
        }
        actions {
          id
        }
      }
    }
  }
}
